import { render, staticRenderFns } from "./ResumeAnalytics.vue?vue&type=template&id=4bdf21ba&scoped=true&"
import script from "./ResumeAnalytics.vue?vue&type=script&lang=js&"
export * from "./ResumeAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./ResumeAnalytics.vue?vue&type=style&index=0&id=4bdf21ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf21ba",
  null
  
)

export default component.exports